import React, { Fragment } from 'react'

import { EDIT_MACROMOLECULE_VIEW } from '../../../constants/saxs'
import { INFO_MESSAGE_TYPE } from '../../../constants/UserMessages'
import SaxsSearchBarBelowEntityList from '../SaxsSearchBarBelowEntityList'
import { Table } from 'react-bootstrap'
import UserMessage from '../UserMessage'
import filter from 'lodash/filter'
import map from 'lodash/map'

/**
 * React component which toggle proper rendering of the sideBar
 * @param {*} props
 */
class SaxsMacromoleculeListPanel extends React.Component {
  constructor(props) {
    super(props)

    this.filter = this.filter.bind(this)
  }

  render() {
    if (
      this.props.proposalInfo.length > 0 &&
      this.props.proposalInfo[0].macromolecules &&
      this.props.proposalInfo[0].macromolecules instanceof Array
    ) {
      if (this.props.proposalInfo[0].macromolecules.length > 0) {
        return (
          <SaxsSearchBarBelowEntityList
            data={this.props.proposalInfo[0].macromolecules}
            filter={this.filter}
            placeholder="Search by acronym"
          >
            {foundMacromolecules => (
              <div>
                <div style={{ paddingLeft: '8px' }}>
                  <strong> {foundMacromolecules.length} </strong> macromolecule
                  {foundMacromolecules.length > 0 ? 's' : null} found.
                </div>
                <MacromoleculesTable
                  macromolecules={foundMacromolecules}
                  setViewAndMacromoleculeId={this.props.setViewAndMacromoleculeId}
                />
              </div>
            )}
          </SaxsSearchBarBelowEntityList>
        )
      }
      return <UserMessage type={INFO_MESSAGE_TYPE} message="No macromolecule exist in this proposal." />
    }
    return <></>
  }

  filter(data, userInput) {
    return filter(data, item => item.acronym.toUpperCase().indexOf(userInput.toUpperCase()) !== -1)
  }
}

export default SaxsMacromoleculeListPanel

/**
 * React component which renders the list of available macromolecules
 * @param {*} props
 */
class MacromoleculesTable extends React.Component {
  render() {
    return (
      <Table striped hover>
        <tbody>
          {map(this.props.macromolecules, macromolecule => (
            <tr key={macromolecule.macromoleculeId}>
              <td
                onClick={() =>
                  this.props.setViewAndMacromoleculeId(EDIT_MACROMOLECULE_VIEW, macromolecule.macromoleculeId)
                }
                style={{ maxWidth: 0 }}
              >
                <div
                  style={{
                    color: '#207a7a',
                    fontWeight: 'bold',
                    textOverflow: 'ellipsis',
                    overflowX: 'hidden',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {macromolecule.acronym}
                </div>
                <div style={{ textOverflow: 'ellipsis', overflowX: 'hidden', whiteSpace: 'nowrap' }}>
                  {macromolecule.name}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }
}
